import React from 'react'
import '../userbox/UserBox.scss'
import CountUp from 'react-countup'

function UserBox({ customColor, boxtitle, num, imagesource }) {
  return (
    <>
      <div className='cardbox-css'>
        <div className='mainbox '>
          <div>
            <p className='box-title'>{boxtitle}</p>
            <p className='box-subheading' style={{ color: customColor }}>
              <CountUp end={num} duration={0.8} />
            </p>
          </div>
          <img src={imagesource} className='usericon' />
        </div>
      </div>
    </>
  )
}

export default UserBox